/**
 * Cart drawer countdown timer.
 * Implemented as a custom element so it reliably initializes whether it's
 * present on initial page load OR inserted later via the theme's DOM morphing
 * (e.g. when the cart drawer updates from empty -> non-empty via AJAX).
 * Plain <script> tags do not re-execute when inserted through morphing/innerHTML,
 * but custom elements always run connectedCallback() when connected to the DOM.
 */
class CartCountdownTimer extends HTMLElement {
  #interval;
  #endTime;

  connectedCallback() {
    const durationMs = 10 * 60 * 1000; // 10 minutes
    const storageKey = 'custom_cart_drawer_end';
    const now = Date.now();

    let endTime = parseInt(sessionStorage.getItem(storageKey) || '', 10);

    if (!endTime || endTime < now) {
      endTime = now + durationMs;
      sessionStorage.setItem(storageKey, String(endTime));
    }

    this.#endTime = endTime;
    this.#tick();
    this.#interval = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    if (this.#interval) clearInterval(this.#interval);
  }

  #tick() {
    const timerEl = this.querySelector('[data-cart-countdown-value]');
    if (!timerEl) return;

    const distance = this.#endTime - Date.now();

    if (distance <= 0) {
      timerEl.textContent = '00:00';
      if (this.#interval) clearInterval(this.#interval);
      return;
    }

    const minutes = Math.floor(distance / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    timerEl.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }
}

if (!customElements.get('cart-countdown-timer')) {
  customElements.define('cart-countdown-timer', CartCountdownTimer);
}
